import { createSlice } from '@reduxjs/toolkit';
import { Account } from 'src/models';
import {
  fetchAccountAction,
  logoutAction,
  fetchCompaniesStatisticsAction,
} from 'src/services/auth';

const initialState: {
  user: Account | null;
  isPending: boolean;
  hasError: boolean;
} = {
  user: null,
  isPending: true,
  hasError: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    clearAuthState: (state) => {
      state.hasError = false;
      state.isPending = false;
      state.user = initialState.user;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAccountAction.pending, (state) => {
      state.isPending = true;
      state.hasError = false;
      state.user = null;
    });
    builder.addCase(fetchAccountAction.fulfilled, (state, { payload }) => {
      state.user = {
        ...payload.user,
        companies: payload.user.companies.map((company) => ({
          ...company,
          todayPaymentCount: 0,
        })),
      };
      state.hasError = false;
      state.isPending = false;
    });
    builder.addCase(fetchAccountAction.rejected, (state) => {
      state.hasError = true;
      state.isPending = false;
    });
    builder.addCase(fetchCompaniesStatisticsAction.pending, (state) => {
      state.hasError = false;
    });
    builder.addCase(
      fetchCompaniesStatisticsAction.fulfilled,
      (state, { payload }) => {
        const paymentToDayMap = payload.reduce(
          (res, current) => {
            return { ...res, [current.companyId]: current.paymentToDay };
          },
          {} as Record<string, number>,
        );

        state.user?.companies.forEach((company) => {
          company.todayPaymentCount = paymentToDayMap[company.id] ?? 0;
        });
        state.hasError = false;
      },
    );
    builder.addCase(fetchCompaniesStatisticsAction.rejected, (state) => {
      state.hasError = true;
    });
    builder.addCase(logoutAction.fulfilled, (state) => {
      state.hasError = false;
      state.isPending = false;
      state.user = initialState.user;
    });
  },
});

export const { clearAuthState } = authSlice.actions;

export default authSlice.reducer;
